// src/utils/portalRecipients.js
// Resolve the pickable recipient list for a portal / forms send: every client
// on a lead, with their name + email, so the PortalRecipientsModal can show
// pre-checked chips. Impure (reads contacts); the pure email helpers live in
// emailFanout.js.
import { getContactsByIds } from "./firebasefunctions";
import { listClients } from "./leadClients";
import { pickEmail, pickName } from "./emailFanout";
import { normalizeContact } from "./contactNormalize";

// [{ contactId, name, email, phone }] for every client on the lead. A person
// with neither email nor phone is "on the file but unreachable" — the modal
// shows them as skipped. Phone matters: the portal link is TEXTED to each
// selected client too, so phone-only clients must be pickable.
export async function resolveLeadRecipients(lead) {
  const clients = listClients(lead);
  const ids = clients.map((c) => c.contactId).filter(Boolean);
  let contacts = [];
  try {
    contacts = ids.length ? (await getContactsByIds(ids)) || [] : [];
  } catch (_) {
    /* fall through — names/emails just come out blank */
  }
  return clients.map((c) => {
    const contact = contacts.find((x) => x && String(x.id) === String(c.contactId));
    return {
      contactId: c.contactId,
      name: pickName(contact) || c.contactName || "",
      email: pickEmail(contact) || (contact ? "" : pickEmail(c)),
      phone: (contact && normalizeContact(contact)?.phone) || "",
    };
  });
}
